import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import router from 'router';
import PrivateRouter from 'router/PrivateRouter';
import { getUserInfo } from 'store/action';
import Loading from './common/Loading';
import AppHeader from './components/AppHeader';
import SideBar from './components/SideBar';
import Authen from './pages/auth';

const Home = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    if (!isAuthenticated && accessToken) {
      dispatch(getUserInfo());
    }
    // eslint-disable-next-line
  }, [accessToken]);

  if (!isAuthenticated && accessToken) {
    return <Loading />;
  }

  return (
    <Routes>
      <Route path="/auth/login" element={<Authen />} />
      <Route path="/auth/register" element={<Authen />} />
      <Route path='/forbidden' element={<div>forbidden</div>} />
      <Route
        path="*"
        element={
          <div className="app-container-wraper">
            <SideBar />
            <div className="app-container">
              <AppHeader />
              <div className="app-body">
                <Routes>
                  {router.map((item) => (
                    <Route
                      key={item.path}
                      path={item.path}
                      element={
                        <PrivateRouter
                          permissions={item.permissions}
                          roles={item.role}
                          element={item.component}
                        />
                      }
                    />
                  ))}
                  <Route
                    path="*"
                    element={<Navigate to="/project" replace />}
                  />
                </Routes>
              </div>
            </div>
          </div>
        }
      />
    </Routes>
  );
};

export default Home;
